import React from 'react';
import { X, Download } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { adminApi } from '@/lib/api';
import { formatFileSize } from './helpers';

export const ImageLightbox = ({ image, onClose, onDownload }) => {
  if (!image) return null;

  return (
    <div
      className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="report-image-lightbox"
    >
      <Button
        variant="ghost"
        size="icon"
        className="absolute top-4 right-4 text-white hover:bg-white/20"
        onClick={onClose}
      >
        <X className="w-6 h-6" />
      </Button>
      <div className="max-w-[90vw] max-h-[90vh] flex flex-col items-center" onClick={(e) => e.stopPropagation()}>
        <img
          src={adminApi.previewAttachment(image.id)}
          alt={image.original_filename}
          className="max-w-full max-h-[80vh] object-contain rounded-lg"
        />
        <div className="mt-4 text-center">
          <p className="text-white text-sm">{image.original_filename}</p>
          <p className="text-white/60 text-xs mt-1">
            {formatFileSize(image.size)} • {image.uploaded_by === 'reporter' ? 'Denunciante' : 'Gestor'}
          </p>
          <Button
            variant="outline"
            size="sm"
            className="mt-3"
            onClick={() => onDownload(image.id, image.original_filename)}
          >
            <Download className="w-4 h-4 mr-2" />
            Descarregar
          </Button>
        </div>
      </div>
    </div>
  );
};
